export default "__VITE_ASSET__ochmKP9___"